import React, { ReactNode } from 'react';

import { CategoriesMobileDisplayOption } from 'src/gql/graphql';
import { CategoriesCarousel } from 'src/components/carousel-v2/types/categories-carousel';
import { Grid, SliderContainer, ViewAllButton, GridContainer, GridHeading } from './list.styles';

type ListProps = {
  children: ReactNode;
  mobileDisplay: CategoriesMobileDisplayOption;
  enableViewAll?: boolean;
  isExpanded?: boolean;
  viewAllItems?: () => void;
  heading?: string;
};

export const List = ({
  children,
  mobileDisplay,
  enableViewAll = true,
  isExpanded,
  viewAllItems,
  heading = 'Categories',
}: ListProps): JSX.Element => {
  const isMobileGrid = mobileDisplay === CategoriesMobileDisplayOption.grid;

  return (
    <>
      {isMobileGrid && (
        <GridContainer>
          {Boolean(heading) && <GridHeading data-testid='categories-carousel-heading'>{heading}</GridHeading>}
          <Grid>{children}</Grid>
          {enableViewAll && !isExpanded && <ViewAllButton onClick={viewAllItems}>View All</ViewAllButton>}
        </GridContainer>
      )}

      <SliderContainer $isMobileGrid={isMobileGrid}>
        <CategoriesCarousel title={heading}>{children}</CategoriesCarousel>
      </SliderContainer>
    </>
  );
};
